module.exports = __webpack_public_path__ + "static/media/image-992.70b7c1b4.webp";